export default async config => {
  const useDynamicConfig = config.dangerouslyUseDynamicConfig;

  // Check if dangerouslyUseDynamicConfig enabled
  if (useDynamicConfig?.enabled) {
    // If enabled then get configUrl query-string
    let query = new URLSearchParams(window.location.search);
    let configHash = query.get('_viewer_request_key');

    if (configHash) {
      // validate regex
      const regex = useDynamicConfig.regex;

      if (configHash.match(regex)) {
        let configUrl = 'https://cloud.rad.direct/direct-api/viewer-v3-conf/' + configHash;

        const response = await fetch(configUrl);
        return response.json();
      } else {
        return null;
      }
    }
  }
  return null;
};
